import { render, staticRenderFns } from "./ItemsProductsReturn.vue?vue&type=template&id=76604852&"
import script from "./ItemsProductsReturn.vue?vue&type=script&lang=js&"
export * from "./ItemsProductsReturn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports